import { cva, type VariantProps } from "class-variance-authority"

export { default as Alert } from "./Alert.vue"
export { default as AlertDescription } from "./AlertDescription.vue"
export { default as AlertTitle } from "./AlertTitle.vue"

// Layout en flex, NO en el grid con `has-[>svg]:` del shadcn de upstream: ese
// depende de la variante `has-*`, que llegó en Tailwind 3.4, y este proyecto
// está en 3.3.3. Sin esa variante las columnas nunca se emiten y el icono
// termina encimado sobre el texto.
export const alertVariants = cva(
  "relative flex w-full items-start gap-3 rounded-lg border px-4 py-3 text-sm [&>svg]:mt-0.5 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-white text-gray-900 [&>svg]:text-gray-500",
        destructive:
          "border-red-200 bg-red-50 text-red-900 [&>svg]:text-red-600",
        warning:
          "border-amber-300 bg-amber-50 text-amber-900 [&>svg]:text-amber-600",
        info: "border-blue-200 bg-blue-50 text-blue-900 [&>svg]:text-blue-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export type AlertVariants = VariantProps<typeof alertVariants>
